import React, { useState, useEffect } from "react";
import { BlackAndWhite } from "../../../../../../themes/Colors";
import useWindowDimensions from "../../../../../../components/get-diemensions/UseWindowDiemensions";
import {
  BaseButtons,
  CheckInput,
  CloseButton,
  TextAreaInput,
  TextInputField,
} from "../../../../../../components/atoms";
import JsPDF from "jspdf";
import AWS from "aws-sdk";

const Section21Manage = ({
  setClose,
  selectedSection21,
  setLoading,
  admin,
  setRefresh,
  refresh,
}) => {
  const { width, height } = useWindowDimensions();
  // this is the section 21 fields needed for application
  const [title, setTitle] = useState("");
  const [fullName, setFullName] = useState("");
  const [surname, setSurname] = useState("");
  const [idNumber, setIdNumber] = useState("");
  const [occupation, setOccupation] = useState("");
  const [age, setAge] = useState("");
  const [gender, setGender] = useState("");
  const [weight, setWeight] = useState("");
  const [heightInCm, setHeightInCm] = useState("");
  const [address, setAddress] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [cellNumber, setCellNumber] = useState("");
  const [alternateNumber, setAlternateNumber] = useState("");
  const [emailAddress, setEmailAddress] = useState("");
  const [diagnosis, setDiagnosis] = useState("");
  const [treatmentDetails, setTreatmentDetails] = useState("");
  const [otherConditions, setOtherConditions] = useState("");
  const [doYouSmokeCannabis, setDoYouSmokeCannabis] = useState("");
  const [anyOtherForm, setAnyOtherform] = useState("");
  const [specify, setSpecify] = useState("");

  const [currentStatus, setCurrentStatus] = useState(
    "PENDING APPLICATION REVIEW"
  );
  const [validUntil, setValidUntil] = useState(null);

  const [section21Number, setSection21Number] = useState(null);

  // store selection variable

  const [allStores, setAllStores] = useState([]);
  const [store, setStore] = useState(null);
  const [storeOpen, setStoreOpen] = useState(false);
  const [imageLink, setImageLink] = useState("");
  const [imageData, setImageData] = useState(null);

  const [selectedUser, setSelectedUser] = useState(null);

  const updateAndSelectAccount = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://budloungedatabase.onrender.com/requestPrescriptionUser/doctorUpdateSection21Status",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            section21docId: selectedSection21._id,
            status: currentStatus,
            validUntil: validUntil,
            copyOfIdDoc: "coming soon",
            diagnosis: diagnosis,
            docId: admin.userId,
          }),
        }
      );

      const responseData = await response.json();
      // console.log("response", responseData);
      if (responseData.success) {
        setClose(null);
        setRefresh(refresh ? false : true);
        // setSection21Array(responseData.section21);
        // setPrescriptionArray(responseData.prescriptionRequest);
        // setAllValidatedUsers(responseData.validatedUsers);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      console.log("error", err);
    }
  };
  const transitPdf = () => {
    return (
      <div
        id="report"
        style={{
          fontFamily: "Arial",
          position: "absolute",
          zIndex: -1,
          width: 595.28,
          backgroundColor: BlackAndWhite.secondary,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          top: 0,

          // this will need to be commented put for the download to vewd properly
          // overflowY: "scroll",
          // height: height,
        }}
      >
        {/* page 1 */}
        <div
          style={{
            minHeight: 841.89,
            maxHeight: 841.89,
            minWidth: 595.28,
            maxWidth: 595.28,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          <img
            style={{ height: 842, width: 596 }}
            src={require("../../../../../../images/section21images/page1.png")}
          />
        </div>
        <div
          style={{
            minHeight: 841.89,
            maxHeight: 841.89,
            minWidth: 595.28,
            maxWidth: 595.28,
            display: "flex",
            flexDirection: "column",
            position: "relative",
          }}
        >
          <img
            style={{ height: "100%", width: "100%" }}
            src={require("../../../../../../images/section21images/page2.png")}
          />
          <div
            style={{ position: "absolute", top: 120, left: 140, fontSize: 12 }}
          >
            {title ? title : " "}
          </div>
          <div
            style={{ position: "absolute", top: 120, left: 270, fontSize: 12 }}
          >
            {fullName ? fullName : " "}
          </div>
          <div
            style={{ position: "absolute", top: 155, left: 140, fontSize: 12 }}
          >
            {surname ? surname : " "}
          </div>
          <div
            style={{ position: "absolute", top: 190, left: 140, fontSize: 12 }}
          >
            {idNumber ? idNumber : " "}
          </div>
          <div
            style={{ position: "absolute", top: 190, left: 440, fontSize: 12 }}
          >
            {occupation ? occupation : " "}
          </div>
          <div
            style={{ position: "absolute", top: 230, left: 140, fontSize: 12 }}
          >
            {age ? age : " "}
          </div>
          <div
            style={{ position: "absolute", top: 230, left: 260, fontSize: 12 }}
          >
            {gender ? gender : " "}
          </div>
          <div
            style={{ position: "absolute", top: 230, left: 410, fontSize: 12 }}
          >
            {weight ? weight : " "}
          </div>
          <div
            style={{ position: "absolute", top: 230, left: 520, fontSize: 12 }}
          >
            {heightInCm ? heightInCm : " "}
          </div>

          <div
            style={{
              position: "absolute",
              top: 265,
              left: 310,
              fontSize: 12,
              // borderStyle: "solid",
              maxWidth: 230,
              minWidth: 230,
            }}
          >
            {address ? address : " "}
          </div>
          <div
            style={{
              position: "absolute",
              top: 340,
              left: 435,
              fontSize: 12,
              // borderStyle: "solid",
              maxWidth: 230,
              minWidth: 230,
            }}
          >
            {postalCode ? postalCode : " "}
          </div>
          <div
            style={{ position: "absolute", top: 380, left: 200, fontSize: 12 }}
          >
            {cellNumber ? cellNumber : " "}
          </div>
          <div
            style={{ position: "absolute", top: 380, left: 450, fontSize: 12 }}
          >
            {alternateNumber ? alternateNumber : " "}
          </div>
          <div
            style={{ position: "absolute", top: 415, left: 310, fontSize: 12 }}
          >
            {emailAddress ? emailAddress : " "}
          </div>
          <div
            style={{ position: "absolute", top: 450, left: 310, fontSize: 12 }}
          >
            {diagnosis ? diagnosis : " "}
          </div>
          <div
            style={{ position: "absolute", top: 525, left: 310, fontSize: 12 }}
          >
            {treatmentDetails ? treatmentDetails : " "}
          </div>
          <div
            style={{ position: "absolute", top: 610, left: 310, fontSize: 12 }}
          >
            {otherConditions ? otherConditions : " "}
          </div>
          <div
            style={{ position: "absolute", top: 695, left: 310, fontSize: 12 }}
          >
            {doYouSmokeCannabis ? doYouSmokeCannabis : " "}
          </div>
          <div
            style={{ position: "absolute", top: 735, left: 310, fontSize: 12 }}
          >
            {anyOtherForm ? anyOtherForm : " "}
          </div>
          <div
            style={{ position: "absolute", top: 735, left: 460, fontSize: 12 }}
          >
            {specify ? specify : " "}
          </div>
        </div>
        <div
          style={{
            minHeight: 841.89,
            maxHeight: 841.89,
            minWidth: 595.28,
            maxWidth: 595.28,
            display: "flex",
            flexDirection: "column",
            position: "relative",
          }}
        >
          <img
            style={{ height: "100%", width: "100%" }}
            src={require("../../../../../../images/section21images/page3.png")}
          />
          <div
            style={{ position: "absolute", top: 110, left: 140, fontSize: 12 }}
          >
            {fullName ? fullName + " " + surname : " "}
          </div>
          <div
            style={{ position: "absolute", top: 185, left: 190, fontSize: 12 }}
          >
            {store ? store.storeName : " "}
          </div>
          <div
            style={{ position: "absolute", top: 215, left: 190, fontSize: 10 }}
          >
            {selectedSection21 ? selectedSection21.storeAddress : " "}
          </div>
          <div
            style={{ position: "absolute", top: 285, left: 190, fontSize: 12 }}
          >
            {fullName ? fullName + " " + surname : " "}
            <div style={{ fontSize: 8, width: 140, marginTop: 5 }}>
              this document was signed digitally on section 21 requested from
              doctor
            </div>
          </div>
          <div
            style={{
              position: "absolute",
              top: 292.5,
              left: 430,
              fontSize: 10,
            }}
          >
            {selectedSection21
              ? selectedSection21.createdOn.substring(0, 10)
              : " "}
          </div>
          <div
            style={{ position: "absolute", top: 745, left: 190, fontSize: 12 }}
          >
            {fullName ? fullName + " " + surname : " "}
            <div style={{ fontSize: 8, width: 140, marginTop: 5 }}>
              this document was signed digitally on section 21 requested from
              doctor
            </div>
          </div>
          <div
            style={{
              position: "absolute",
              top: 752.5,
              left: 430,
              fontSize: 10,
            }}
          >
            {selectedSection21
              ? selectedSection21.createdOn.substring(0, 10)
              : " "}
          </div>
        </div>
        <div
          style={{
            minHeight: 841.89,
            maxHeight: 841.89,
            minWidth: 595.28,
            maxWidth: 595.28,
            display: "flex",
            flexDirection: "column",
            position: "relative",
          }}
        >
          <img
            style={{ height: "100%", width: "100%" }}
            src={require("../../../../../../images/section21images/page4.png")}
          />
          <div
            style={{ position: "absolute", top: 100, left: 100, fontSize: 12 }}
          >
            {fullName ? fullName + " " + surname : " "}
            {/* <div style={{ fontSize: 8, width: 140, marginTop: 5 }}>
              this document was signed digitally on section 21 requested from
              doctor
            </div> */}
          </div>
          <div
            style={{
              position: "absolute",
              top: 597.5,
              left: 120,
              fontSize: 10,
            }}
          >
            {selectedSection21
              ? selectedSection21.createdOn.substring(0, 10)
              : " "}
          </div>
          <div
            style={{ position: "absolute", top: 655, left: 240, fontSize: 12 }}
          >
            {fullName ? fullName + " " + surname : " "}
            {/* <div style={{ fontSize: 8, width: 140, marginTop: 5 }}>
              this document was signed digitally on section 21 requested from
              doctor
            </div> */}
          </div>
          <div
            style={{ position: "absolute", top: 715, left: 240, fontSize: 12 }}
          >
            {fullName ? fullName + " " + surname : " "}
            <div style={{ fontSize: 8, width: 140, marginTop: 5 }}>
              this document was signed digitally on section 21 requested from
              doctor
            </div>
          </div>
        </div>
        <div
          style={{
            minHeight: 841.89,
            maxHeight: 841.89,
            minWidth: 595.28,
            maxWidth: 595.28,
            display: "flex",
            flexDirection: "column",
            position: "relative",
          }}
        >
          <img
            style={{ height: "100%", width: "100%" }}
            src={require("../../../../../../images/section21images/page5.png")}
          />
          <div
            style={{ position: "absolute", top: 165, left: 100, fontSize: 12 }}
          >
            {fullName ? fullName + " " + surname : " "}
            {/* <div style={{ fontSize: 8, width: 140, marginTop: 5 }}>
              this document was signed digitally on section 21 requested from
              doctor
            </div> */}
          </div>
          <div
            style={{ position: "absolute", top: 735, left: 190, fontSize: 12 }}
          >
            {fullName ? fullName + " " + surname : " "}
            <div style={{ fontSize: 8, width: 140, marginTop: 5 }}>
              this document was signed digitally on section 21 requested from
              doctor
            </div>
          </div>
          <div
            style={{
              position: "absolute",
              top: 742.5,
              left: 425,
              fontSize: 10,
            }}
          >
            {selectedSection21
              ? selectedSection21.createdOn.substring(0, 10)
              : " "}
          </div>
        </div>
      </div>
    );
  };
  const generatePDF = async () => {
    // prescriptionPdf();

    const report = await new JsPDF("portrait", "px", [595.28, 841.89]);
    report.html(document.querySelector("#report")).then(() => {
      report.getFontList();

      report.save(
        `section21Applicationfor${
          selectedSection21.fullNames + " " + selectedSection21.surname
        }.pdf`
      );
    });
  };
  const OnUserSearch = async () => {
    // setLoading(true);

    try {
      const response = await fetch(
        "https://budloungedatabase.onrender.com/user/searchForValidatedUserPos",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            searchParameter: selectedSection21.idNumber,
            userId: admin.userId,
          }),
        }
      );

      const responseData = await response.json();

      // setLoading(false);
      if (responseData.success) {
        setSelectedUser(responseData.data[0]);
      }
    } catch (err) {
      console.log("err", err);
      // setLoading(false);
    }
  };

  const getUplaodImage = async () => {
    const S3_BUCKET = process.env.REACT_APP_BUCKET;
    const apiKey = process.env.REACT_APP_AWS_ACCESS_KEY_ID;
    const secrectapiKey = process.env.REACT_APP_AWS_SECRET_KEY_ID;
    AWS.config.update({
      accessKeyId: apiKey,
      secretAccessKey: secrectapiKey,
    });
    const s3 = new AWS.S3({
      params: { Bucket: S3_BUCKET },
      region: process.env.REACT_APP_REGION,
      signatureVersion: "v4",
    });

    const params = {
      Bucket: S3_BUCKET,
      Key: `${selectedUser.image}`,
    };

    var promise = s3.getSignedUrlPromise("getObject", params);
    // return promise;
    promise.then(
      function (url) {
        if (url) {
          setImageLink(url);
        }
        return url;
      },
      function (err) {
        console.log(err);
      }
    );
  };

  useEffect(() => {
    if (selectedSection21) {
      setTitle(selectedSection21.title);
      setFullName(selectedSection21.fullNames);
      setSurname(selectedSection21.surname);
      setIdNumber(selectedSection21.idNumber);
      setOccupation(selectedSection21.occupation);
      setAge(selectedSection21.age);
      setGender(selectedSection21.gender);
      setWeight(selectedSection21.weightInKg);
      setHeightInCm(selectedSection21.heightInCm);
      setAddress(selectedSection21.address);
      setPostalCode(selectedSection21.postalCode);
      setCellNumber(selectedSection21.cellNumber);
      setAlternateNumber(selectedSection21.alternateNumber);
      setEmailAddress(selectedSection21.emailAddress);
      setDiagnosis(selectedSection21.diagnosis);
      setOtherConditions(selectedSection21.otherConditions);
      setTreatmentDetails(selectedSection21.treatmentDetails);
      setDoYouSmokeCannabis(selectedSection21.doYouSmokeCannabis);
      setAnyOtherform(selectedSection21.anyOtherWays);
      setSpecify(selectedSection21.specify);
      setCurrentStatus(selectedSection21.status);
      setStore({
        storeName: selectedSection21.storeName,
      });
      if (selectedSection21.validUntil) {
        setValidUntil(selectedSection21.validUntil);
      }
    }
  }, [selectedSection21]);

  useEffect(() => {
    OnUserSearch();
  }, [selectedSection21]);

  useEffect(() => {
    if (admin && selectedUser) {
      getUplaodImage();
    }
  }, [selectedUser]);
  return (
    <div
      style={{
        position: "fixed",
        width: width - 220,
        height: height - 60,

        backgroundColor: BlackAndWhite.secondary,
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 20,
          left: 20,
          display: "flex",
          alignItems: "center",
          width: "97%",
        }}
      >
        <CloseButton label={"X"} onClick={() => setClose(null)} />{" "}
        <div style={{ fontWeight: "bold", marginLeft: 20, fontSize: 18 }}>
          Manage Section 21 Application
        </div>
        <div style={{ flex: 1 }} />
        <BaseButtons
          label={"DOWNLOAD"}
          mini={true}
          marginTopFalse={true}
          height={35}
          onClick={() => generatePDF()}
          marginRight={20}
        />
        <BaseButtons
          label={"UPDATE"}
          mini={true}
          marginTopFalse={true}
          height={35}
          onClick={() => updateAndSelectAccount()}
        />
      </div>
      <div
        style={{
          width: "100%",
          height: "100%",
          marginTop: 60,
          backgroundColor: BlackAndWhite.secondary,
          zIndex: 1,
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            overflowY: "scroll",
            overflowX: "hidden",
            height: "100%",
            zIndex: 1,
          }}
        >
          <div
            style={{
              width: "90%",
              fontWeight: "bold",
              fontSize: 20,
              marginLeft: 90,
              marginTop: 25,
            }}
          >
            Section 21 application
          </div>
          <div style={{ width: "90%", marginTop: 20 }}>
            1. Supporting Documents Required:
          </div>

          <div style={{ width: "90%" }}> • Copy of ID</div>

          <div
            style={{
              width: "90%",
              marginTop: 20,
              fontWeight: "bold",
            }}
          >
            <TextInputField
              labelTitle={"Title"}
              invert={true}
              onChange={(event) => setTitle(event.target.value)}
              mini={true}
              size={"90%"}
              value={title}
              readOnly={selectedSection21}
            />
            <TextInputField
              labelTitle={"Full names"}
              invert={true}
              onChange={(event) => setFullName(event.target.value)}
              mini={true}
              size={"90%"}
              value={fullName}
              readOnly={selectedSection21}
            />
            <TextInputField
              labelTitle={"Surname"}
              invert={true}
              onChange={(event) => setSurname(event.target.value)}
              mini={true}
              size={"90%"}
              value={surname}
              readOnly={selectedSection21}
            />
            <TextInputField
              labelTitle={"Id number"}
              invert={true}
              onChange={(event) => setIdNumber(event.target.value)}
              mini={true}
              value={idNumber}
              size={"90%"}
              readOnly={selectedSection21}
            />
            <TextInputField
              labelTitle={"Occupation"}
              invert={true}
              onChange={(event) => setOccupation(event.target.value)}
              mini={true}
              size={"90%"}
              value={occupation}
              readOnly={selectedSection21}
            />
            <TextInputField
              labelTitle={"Age"}
              invert={true}
              onChange={(event) => setAge(event.target.value)}
              mini={true}
              size={"90%"}
              value={age}
              readOnly={selectedSection21}
            />
            <TextInputField
              labelTitle={"Gender"}
              invert={true}
              onChange={(event) => setGender(event.target.value)}
              mini={true}
              size={"90%"}
              value={gender}
              readOnly={selectedSection21}
            />
            <TextInputField
              labelTitle={"Weigth in Kg"}
              invert={true}
              onChange={(event) => setWeight(event.target.value)}
              mini={true}
              value={weight}
              size={"90%"}
              readOnly={selectedSection21}
            />

            <TextInputField
              labelTitle={"height in cm"}
              invert={true}
              onChange={(event) => setHeightInCm(event.target.value)}
              mini={true}
              size={"90%"}
              value={heightInCm}
              readOnly={selectedSection21}
            />
            <TextAreaInput
              labelTitle={"Address"}
              color={BlackAndWhite.primary}
              invert={true}
              onChange={(event) => setAddress(event.target.value)}
              mini={true}
              size={"90%"}
              value={address}
              readOnly={selectedSection21}
            />
            <TextInputField
              labelTitle={"Postal code"}
              invert={true}
              onChange={(event) => setPostalCode(event.target.value)}
              mini={true}
              size={"90%"}
              value={postalCode}
              readOnly={selectedSection21}
            />
            <TextInputField
              labelTitle={"Cell number"}
              invert={true}
              onChange={(event) => setCellNumber(event.target.value)}
              mini={true}
              size={"90%"}
              value={cellNumber}
              readOnly={selectedSection21}
            />
            <TextInputField
              labelTitle={"Alternate number"}
              invert={true}
              onChange={(event) => setAlternateNumber(event.target.value)}
              mini={true}
              size={"90%"}
              value={alternateNumber}
              readOnly={selectedSection21}
            />
            <TextInputField
              labelTitle={"Email address"}
              invert={true}
              onChange={(event) => setEmailAddress(event.target.value)}
              mini={true}
              size={"90%"}
              value={emailAddress}
              readOnly={selectedSection21}
            />
            <TextAreaInput
              labelTitle={
                "Diagnosis – Full description including severity, staging and prognosis where applicable: Example: Chronic Pain, Anxiety, Fibromyalgia etc.– Please give a full description."
              }
              color={BlackAndWhite.primary}
              invert={true}
              onChange={(event) => setDiagnosis(event.target.value)}
              mini={true}
              size={"90%"}
              value={diagnosis}
              readOnly={selectedSection21}
            />
            <TextAreaInput
              labelTitle={
                "Details of current treatment regimen for the abovediagnosis. Include medical, surgical and other treatment: Example: Aspirin, Ibuprofen, Naproxen, Serotonin and Norepinephrine."
              }
              color={BlackAndWhite.primary}
              invert={true}
              onChange={(event) => setTreatmentDetails(event.target.value)}
              mini={true}
              size={"90%"}
              value={treatmentDetails}
              readOnly={selectedSection21}
            />
            <TextAreaInput
              labelTitle={
                "Do you suffer from any other conditions not yet mentioned? If yes, please specify as well as current treatment. Example: High Blood Pressure, Cholesterol, Diabetes etc."
              }
              color={BlackAndWhite.primary}
              invert={true}
              onChange={(event) => setOtherConditions(event.target.value)}
              mini={true}
              size={"90%"}
              value={otherConditions}
              readOnly={selectedSection21}
            />
            <TextInputField
              labelTitle={"Do you smoke Cannabis?"}
              invert={true}
              onChange={(event) => setDoYouSmokeCannabis(event.target.value)}
              mini={true}
              size={"90%"}
              value={doYouSmokeCannabis}
              readOnly={selectedSection21}
            />
            <TextInputField
              labelTitle={"Do you use Cannabis in any other form?"}
              invert={true}
              onChange={(event) => setAnyOtherform(event.target.value)}
              mini={true}
              size={"90%"}
              value={anyOtherForm}
              readOnly={selectedSection21}
            />
            <TextInputField
              labelTitle={"Specify"}
              invert={true}
              onChange={(event) => setSpecify(event.target.value)}
              mini={true}
              size={"90%"}
              value={specify}
              readOnly={selectedSection21}
            />
            <div style={{ marginTop: 40 }}>Store Collection point request</div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
              }}
            >
              <BaseButtons
                label={store ? store.storeName : "loading"}
                mini={true}
                size={"93%"}
              />
            </div>

            {/* <TextInputField
              labelTitle={"Store Name"}
              invert={true}
              // onChange={(event) => setAnswer1(event.target.value)}
              mini={true}
              size={"90%"}
              value={store ? store.storeName : "loading"}
            /> */}
            <TextAreaInput
              readOnly={selectedSection21}
              labelTitle={"Store Address"}
              color={BlackAndWhite.primary}
              invert={true}
              // onChange={(event) => setAnswer1(event.target.value)}
              mini={true}
              value={
                selectedSection21
                  ? selectedSection21.storeAddress
                  : store
                  ? store.unitNumber +
                    " " +
                    store.streetAddress +
                    ", " +
                    store.suburb +
                    ", " +
                    store.city +
                    ", " +
                    store.postalCode
                  : "loading"
              }
              size={"90%"}
            />

            <div
              style={{
                color: BlackAndWhite.primary,
                marginTop: 40,
              }}
            >
              Status
              <div
                style={{
                  marginTop: 15,
                  fontWeight: "normal",
                  display: "flex",
                  width: "90%",
                  justifyContent: "space-evenly",
                }}
              >
                <CheckInput
                  question={"REQUESTED"}
                  onClick={() => setCurrentStatus("REQUESTED")}
                  mini={true}
                  invert={true}
                  check={currentStatus === "REQUESTED" ? true : false}
                />
                <CheckInput
                  question={"PENDING REVIEW"}
                  onClick={() => setCurrentStatus("PENDING REVIEW")}
                  mini={true}
                  invert={true}
                  check={currentStatus === "PENDING REVIEW" ? true : false}
                />
                <CheckInput
                  question={"APPROVED"}
                  onClick={() => setCurrentStatus("APPROVED")}
                  mini={true}
                  invert={true}
                  check={currentStatus === "APPROVED" ? true : false}
                />
              </div>
            </div>
            <div style={{ marginTop: 20 }}>
              <TextInputField
                labelTitle={"Valid Until"}
                invert={true}
                onChange={(event) => setValidUntil(event.target.value)}
                mini={true}
                size={"90%"}
                value={validUntil}
                //   readOnly={selectedSection21}
              />
            </div>
            <div style={{ marginTop: 20 }}>
              <TextInputField
                labelTitle={"SECTION 21 NUMBER"}
                invert={true}
                onChange={(event) => setSection21Number(event.target.value)}
                mini={true}
                size={"90%"}
                value={section21Number}
                //   readOnly={selectedSection21}
              />
            </div>

            <div style={{ marginTop: 20, marginBottom: 20 }}>ID DOCUMENT</div>
            <img alt="id doc" src={imageLink} style={{ width: "90%" }} />
            {/* <div style={{ minHeight: 20 }} /> */}

            <div style={{ minHeight: 20 }} />
          </div>
          <div style={{ minHeight: 200 }} />
        </div>
        {transitPdf()}
      </div>
    </div>
  );
};

export default Section21Manage;
